import { useParams } from 'react-router-dom';
import './index.less';
import { Input, message, Select, Upload } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useContext, useEffect, useRef, useState } from 'react';
import { ReactComponent as PreviewSvg } from '@/commons/icons/info-detail/element/preview.svg'
// import { ReactComponent as SelectSvg } from '@/commons/icons/info-detail/element/select.svg'
import { ReactComponent as SelectSvg } from '../../icnos/pick.svg'
import { ReactComponent as DeleteSvg } from '@/commons/icons/info-detail/element/delete.svg'
import { ReactComponent as EditSvg } from '@/commons/icons/info-detail/element/edit.svg'
import { RecordStatusOptions } from '@/commons/enums/record-status';
import { InfoUpObj, Element, ElementFile, Record } from '@/commons/interface/project/info-detail';
import { createInfoUp } from '@/api/project/element';
import { FileUploadParam, UploadFileLocale } from 'tncet-common';
import { UploadFileContext } from '@/App';
import { graphicStore } from '@/commons/store/graphic-store';
import { ModelBase } from '.yalc/pytha/dist';
import { Group } from '@/commons/interface/speccommon/group';
import { GroupType } from '@/commons/enums/group';
import { getGroupsByBuildingUuid } from '@/api/spec-common/group';
import classNames from 'classnames';



export default function InfoElementPanel() {

    const { projectUuid, buildingUuid } = useParams();
    const uploadFileContext = useContext(UploadFileContext);

    const [loading, setLoading] = useState(false);
    const [uploadFileList, setUploadFileList] = useState([]);   // 上传的文件列表

    const [element, setElement] = useState<Element>(null);
    const [record, setRecord] = useState<Record>(null);
    const [groups, setGroups] = useState<Group[]>([]);

    const [isActiveSelect, setIsActiveSelect] = useState<boolean>(false);
    useEffect(() => {
        // TODO 获取组
        getGroupsByBuildingUuid(projectUuid, buildingUuid).then(res => {
            let data: Group[] = res.data || [];
            data = data?.map(item => {
                item.hidden = true;
                return item;
            })
            setGroups(data);
        })
    }, [projectUuid, buildingUuid])

    /**
     * 上传前置
     * @param file 
     * @param fileList 
     * @returns 
     */
    const beforeUpload = (file, fileList) => {
        if (uploadFileList.length === 0) {
            setUploadFileList([...fileList]);
        }
        return false;
    }

    useEffect(() => {
        return () => {
            const editor = graphicStore.extraContext.getCurrentViewEditor();
            if (!!editor) {
                editor.listeners.signals.onSelectChanged.remove(handleSelect);
            }
        }
    }, [])

    useEffect(() => {
        if (uploadFileList.length === 0) return;
        let files: UploadFileLocale[] = uploadFileList.map(item => {
            return {
                file: item,
                callbackFn: uploadCallbackFn
            }
        })
        uploadFileContext.startUpload(files)
    }, [uploadFileList])

    useEffect(() => {
        if (!uploadFileContext.visible && uploadFileList.length > 0) {
            setUploadFileList([]);
        }
    }, [uploadFileContext.visible])

    const uploadCallbackFn = (uploadFile: FileUploadParam) => {
        return new Promise(resolve => {
            const elementFile: ElementFile = {
                md5: uploadFile.md5,
                name: uploadFile.name,
                suffix: uploadFile.suffix,
                fileSize: uploadFile.fileSize,
                filePath: uploadFile.filePath
            }
            setElement({ ...element, files: [...element?.files || [], elementFile] });
            resolve(true);
        })
    }

    // 从文件列表删除
    const deleteFile = (file) => {
        const fileIndex = element?.files.findIndex(f => f.md5 === file.md5);
        if (fileIndex === -1) {
            message.warning("文件不存在")
            return;
        }
        const newFileList = [...element?.files];
        newFileList.splice(fileIndex, 1);
        setElement({ ...element, files: newFileList });
        message.success("文件已删除");
    }

    // 预览文件
    const previewFile = (file) => {

    }

    // 确认上传
    const confirmUpload = () => {
        if (loading) return;
        const res1 = verifyObj();
        if (!res1) return;
        const reqData: InfoUpObj = {
            files: element?.files || [],
        }
        reqData.files.forEach(f => f.type = element.name);
        const res2 = verifyRecord();
        if (!res2) return;
        if (record != null) reqData.record = record;
        setLoading(true);
        createInfoUp(reqData, element.name).then(res => {
            if (res.status === 200) {
                message.success("上传成功");
                return;
            }
            message.error("上传失败");
        }).catch(err => {
            message.error("上传失败");
        }).finally(() => {
            setElement(null);
            setRecord(null);
            setLoading(false);
        })
    }

    // 检查对象属性
    const verifyObj = () => {
        if (element == null) {
            message.warning("对象属性不能为空");
            return false;
        }
        // if (element.name == null || element.name === '') {
        //     message.warning("对象名称不能为空");
        //     return false;
        // }
        // if (element.route == null || element.route === '') {
        //     message.warning("对象路径不能为空");
        //     return false;
        // }
        // if (element.function == null || element.function === '') {
        //     message.warning("对象功能描述不能为空");
        //     return false;
        // }
        return true;
    }

    // 检查记录属性
    const verifyRecord = () => {
        if (record == null) {
            return true;
        }
        // if (record.type == null) {
        //     message.warning("记录状态不能为空");
        //     return false;
        // }
        // if (record.title == null || record.title === '') {
        //     message.warning("记录标题不能为空");
        //     return false;
        // }
        // if (record.content == null || record.content === '') {
        //     message.warning("记录内容不能为空");
        //     return false;
        // }
        return true;
    }

    const buildObj = (entity: ModelBase) => {
        let obj = {};
        treeRef.current = '';
        buildPath(entity.group[GroupType.GROUP] || []);
        obj['route'] = treeRef.current;
        obj['type'] = entity.type;

        if (entity.type === "ColumnT") {
            // 柱子
            obj['name'] = "立柱";
            obj['function'] = "竖向传力构件";
        } else if (entity.opacity < 1) {
            // 玻璃
            obj['name'] = "玻璃隔断";
            obj['function'] = "维护构件，用于分隔空间";
        } else if (entity.type === "FireHydrantT") {
            // 消火栓
            obj['name'] = "消火栓";
            obj['function'] = "在火灾发生时排除危险，确保人员的安全";
        } else if (entity.type === "TunnelT") {
            // 管道
            obj['name'] = "消防管道";
            obj['function'] = "消防供水";
        } else if (entity.type === "SprayHeadT") {
            // 烟感器
            obj['name'] = "烟感器";
            obj['function'] = "感应到火灾烟雾时自动洒水灭火";
        } else if (entity.type === "FireExtinguisherT") {
            // 灭火器
            obj['name'] = "灭火器";
            obj['function'] = "手持式灭火设备";
        }
        return obj;
    }

    const activeSelect = () => {
        const editor = graphicStore.extraContext.getCurrentViewEditor();
        if (!editor) return;
        // 发送信号，激活
        editor.listeners.signals.onSelectChanged.remove(handleSelect);
        editor.listeners.signals.emptySelectedEntities.dispatch();
        editor.listeners.signals.onSelectChanged.add(handleSelect);
        setIsActiveSelect(true);
        message.info("请选择图元对象");
    }

    const handleSelect = (selectEntities: ModelBase[]) => {
        if (selectEntities.length === 0 || !selectEntities[0].isSelected) {
            message.warning("请选择对象");
            return;
        }
        const entity = selectEntities[0];
        let obj = buildObj(entity);
        // 只获取第一个对象
        setElement({ ...element, uuid: entity.uuid, ...obj });
        message.success("选择对象成功");
        const editor = graphicStore.extraContext.getCurrentViewEditor();
        editor.listeners.signals.onSelectChanged.remove(handleSelect);
        setIsActiveSelect(false);
    }

    const treeRef = useRef<string>('');

    const buildPath = (groupIds: string[]) => {
        if (groups?.length === 0) return [];
        let groupMap: { [key: string]: Group } = {};
        // let tree: (Group & { level?: number })[] = [];
        // 构建dict
        groups?.forEach(group => {
            groupMap[group?.uuid] = { ...group, children: [], level: 1 };
        });
        let tree = [];
        // 构建树
        groupIds.forEach(uuid => {
            let group = groupMap[uuid];
            if (group == null) return;
            if (tree.find(item => item.uuid == group.uuid)) return;
            searchParent(group, groupMap, tree);
        })

        return tree;
    };

    const searchParent = (group: Group, groupMap: { [key: string]: Group }, tree: Group[]) => {
        const parent = groupMap[group?.parentUuid];
        if (parent) {
            searchParent(parent, groupMap, tree);
        }
        if (treeRef.current == '') {
            treeRef.current += `${group.name}`
        } else {
            treeRef.current += `>>${group.name}`
        }
        tree.push(group);
    }

    return <div className='info-up-panel'>
        <div className='panel-title'>新增对象</div>
        <div className='panel-content'>
            <div className='obj-item'>
                <div className='item-label'>对象</div>
                <Input value={element?.name} placeholder='请输入对象名称'
                    onChange={(e) => setElement({ ...element, name: e.target.value })} />
                <div className={classNames({
                        'icon select-icon': true,
                        'active': isActiveSelect
                    })} onClick={activeSelect} >
                    <SelectSvg />
                </div>

            </div>
            <div className='obj-item'>
                <div className='item-label'>路径</div>
                <Input value={element?.route} placeholder='请输入对象路径'
                    onChange={(e) => setElement({ ...element, route: e.target.value })} />
            </div>
            <div className='obj-item'>
                <div className='item-label'>功能</div>
                <TextArea value={element?.function} autoSize={{ minRows: 2, maxRows: 2 }}
                    placeholder='请输入对象功能描述'
                    onChange={(e) => setElement({ ...element, function: e.target.value })} />
            </div>
            <Upload showUploadList={false} beforeUpload={beforeUpload}>浏览本地文件夹</Upload>
            <div className='file-list'>
                {element?.files?.map((file, index) => {
                    return <div className='file-item'>
                        <div className='item-name ellipsis' key={index}>{file.name}</div>
                        <div className='item-ope'>
                            {/* <PreviewSvg onClick={() => previewFile(file)} /> */}
                            <DeleteSvg onClick={() => deleteFile(file)} />
                        </div>
                    </div>
                })}
            </div>
            <div className='record'>
                <Select placeholder="记录状态" value={record?.type} options={RecordStatusOptions}
                    onChange={(value) => setRecord({ ...record, type: value })} />
                <Input value={record?.title} placeholder='记录标题' onChange={(e) => setRecord({ ...record, title: e.target.value })} />
            </div>
            <div className='record-desc'>
                <EditSvg style={{ marginTop: '5px' }} />
                <TextArea placeholder='请输入记录说明' value={record?.content} autoSize={{ maxRows: 9 }}
                    onChange={(e) => setRecord({ ...record, content: e.target.value })} />
            </div>
        </div>
        <div className='panel-footer-btn' onClick={confirmUpload}>上传</div>
    </div>
}